module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9992/js/img/CRM.svg"